import { motion, useReducedMotion } from "framer-motion";

/**
 * Reveal — fades + lifts its children into view on scroll.
 * Respects prefers-reduced-motion (renders statically when reduced).
 */
export const Reveal = ({ children, delay = 0, y = 22, className = "", as = "div" }) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
